export default __webpack_public_path__ + "static/media/samsung-galaxy-a05s.d95a7ae5.png";